// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type CheckShield40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const CheckShield40Filled: FC<CheckShield40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="m18.194 25.417 9.473-9.473-1.959-1.93-7.43 7.43-3.972-3.972-2.014 2.014 5.902 5.93ZM20 36.639c-3.88-.972-7.072-3.215-9.576-6.73-2.505-3.513-3.757-7.381-3.757-11.604v-10l13.333-5 13.333 5v10c0 4.223-1.252 8.09-3.757 11.605-2.504 3.514-5.696 5.757-9.576 6.729Z" />
        </svg>
    );
};

export default CheckShield40Filled;
